import { createFileRoute } from '@tanstack/react-router';
import { RemindersSettingsPage } from '@/features/scheduling/pages/reminders-settings-page';

export const Route = createFileRoute('/_app/settings/reminders')({ component: RemindersSettingsPage });
